import { Component, OnInit } from '@angular/core';
import { Location } from "@angular/common";
import { Router, ActivatedRoute } from "@angular/router";

import { FireDataService } from '../fire-data.service';

import { CaseType } from '../case-type';
import { CASES } from '../case-list';
import { CaseData } from '../case-data';

@Component({
  selector: 'app-case-master',
  templateUrl: './case-master.component.html',
  styleUrls: ['./case-master.component.css']
})
export class CaseMasterComponent implements OnInit {

  cases: CaseType[];
  caseData: CaseData;
  caseId: Number
  selectedCase: CaseType
  caseButton = [{text:'Save', enabled: false, show: true}, {text:'Revert', enabled: false, show: true}, 
                    {text:'Delete', enabled: false, show: true}, {text:'Add Teacher', enabled: false, show: false}];
  groupModel: object
  teacherModel: object
  showTeacherComponent = true
  groupModelChanges = 0   // not used yet, I try to manage disable fields on group model when needed, must be design better
  groupModelSetup = {"teachers":[], "inizializeModel": true, "disableModel": false, "showComponent": false, "showJson": false}
  teacherModelSetup = {"inizializeModel": true, "groupModel" : {}, "showComponent": false, "showJson": false}
  formControlSetup = {canSave: true, message: ""}
  formControl: object
  
  constructor(private fds: FireDataService, private router: Router, private route: ActivatedRoute, private location: Location) {
    
   }

  ngOnInit() {
    this.cases = CASES;
    this.route.params.subscribe(params => {
        this.caseId = Number(params["id"]);
        this.inizializeModel()
        //console.log("CM --> ngOnInit ..:", this.groupModel)
      })
  }

  private inizializeModel() {
    this.groupModel = this.fds.copyArray(this.groupModelSetup)
    this.teacherModel = this.fds.copyArray(this.teacherModelSetup)
    this.formControl = this.fds.copyArray(this.formControlSetup)
    var parId = this.caseId
      function findId(el) {
        return el.id == parId;
      }
    this.selectedCase = this.cases[this.cases.findIndex(findId)]
    if(!this.selectedCase || this.selectedCase.hidden == true) [this.goBack()]
    if (this.selectedCase['component'] == 'special') {this.inizializeCase('special', this.selectedCase.id)}  
    if (this.selectedCase['component'] == 'group') {this.inizializeCase('group', this.selectedCase.id)} 
    if (this.selectedCase['component'] == 'teacher') {this.inizializeCase('teacher', this.selectedCase.id)} 

  }

  private inizializeCase(type, parId) {
    function findId(el) {
      return el.id == parId;
    }
    switch (type) {
      case 'special':
        this.groupModel['caseProperty'] = this.cases[this.cases.findIndex(findId)]
        this.setCommand('isCase15')
        parId = 16
        this.teacherModel['caseProperty'] = this.cases[this.cases.findIndex(findId)]
        break;
      case 'group':
        this.groupModel['caseProperty'] = this.cases[this.cases.findIndex(findId)]
        this.groupModel['note'] = this.groupModel['caseProperty']['note'] ? this.groupModel['caseProperty']['note'] : null
        this.setCommand('isCaseNot15')
        break;
      case 'teacher':
        this.teacherModel['caseProperty'] = this.cases[this.cases.findIndex(findId)]
        this.setCommand('isCaseNot15')
        break;
      default:
    }

  }

  groupIsChanged(par) {
    this.groupModel = par
    this.teacherModel['groupModel'] = this.groupModel
    console.log("CASE-MASTER --> Group is changed...:", this.groupModel)
    this.setCommand('groupIsChanged')
  }

  teacherIsChanged(par) {
    this.teacherModel = par
    //console.log("CASE-MASTER --> Teacher is changed...:", this.teacherModel)
    this.setCommand('teacherIsChanged')
    //if (this.teacherModel['teacher'] && this.teacherModel['groupModel']['showAddTeacher'] ) {this.caseButton[3]['enabled'] = true}
  }

  gridIsSelected(par) {
    //var str = JSON.stringify(par)
    //console.log("Row from grid..:", par)
    if (this.selectedCase['component'] == 'special') {
      this.gridIsSelectedCase('special', par)
    }
    if (this.selectedCase['component'] == 'group') {
      this.gridIsSelectedCase('group', par)
    } 
    if (this.selectedCase['component'] == 'teacher') {
      this.gridIsSelectedCase('teacher', par)
    }
    this.setCommand('gridIsSelected')
  }

  private gridIsSelectedCase(type, par) {
    switch (type) {
      case 'special':
        this.groupModel = this.fds.copyArray(this.groupModelSetup)
        for(var i in par) {
          this.groupModel[i] = par[i]
        }
        this.groupModel['group'] = par['firstTeacher'].substr(3)
        this.groupModel['isEditingMode'] = true
        this.groupModel['showComponent'] = true
        this.fds.readMultipleCases(par['regDateLinked'])
        .then(res => {
          for (var i in res) {res[i]['teacher'] = res[i].firstTeacher.substr(3)}
          this.groupModel['teachers'] = res
        })
        .catch(err => {
          var str = JSON.stringify(err)
          alert(`error reading multiple cases: ${str}`)
        })
        this.teacherModel['groupModel'] = this.groupModel 
        break;
      case 'group' :
        this.groupModel = this.fds.copyArray(this.groupModelSetup)
        for(var i in par) {
          this.groupModel[i] = par[i]
        }
        this.groupModel['group'] = par['firstTeacher'].substr(3)
        this.groupModel['caseProperty'] = this.selectedCase
        this.groupModel['isEditingMode'] = true
        this.groupModel['showComponent'] = true
        break;
      case 'teacher' :      // manca recupero schedulazione dispo a pagamento da passare per il mercge con la schedulazione del periodo selezinato
        this.teacherModel = this.fds.copyArray(this.teacherModelSetup)
        for(var i in par) {
          this.teacherModel[i] = par[i]
        }
        this.teacherModel['type'] = par['firstTeacher'].substr(0,1)
        this.teacherModel['teacher'] = par['firstTeacher'].substr(3)
        this.teacherModel['previousEndDate'] = par['endDate']
        this.teacherModel['caseProperty'] = {}
        this.teacherModel['isEditingMode'] = true
        this.teacherModel['showComponent'] = true
        break;
      default:
    }
  }

  public goBack() {
    this.location.back();
  }

  onSubmit(ops) {
    var self = this;
    var editDate;
    switch (ops) {
      case this.caseButton[1]['text'] :   // Revert
        this.inizializeModel()
        this.setCommand(this.caseButton[1]['text'])
        break;
      case this.caseButton[3]['text'] :   // Add Teacher
        delete this.teacherModel['groupModel']
        this.groupModel['teachers'].push(this.teacherModel)
        var caseProperty = this.teacherModel['caseProperty']
        this.teacherModel = this.fds.copyArray(this.teacherModelSetup)
        this.teacherModel['caseProperty'] = caseProperty
        this.teacherModel['groupModel'] = this.groupModel
        this.teacherModel['showComponent'] = true
        this.caseButton[3]['enabled'] = false
        this.setCommand(this.caseButton[3]['text'])
        break;
      case this.caseButton[0]['text'] :   // Save or Update
        //console.log("First button clicked ...:", this.caseButton[0]['text'])
        if (this.selectedCase['component'] == 'special') {
          var casesToSave = this.buildCasesToSave(this.groupModel)
        } 
        if (this.selectedCase['component'] == 'group') {
          var casesToSave = this.buildSingleCaseToSave(this.groupModel)
        }
        if (this.selectedCase['component'] == 'teacher') {
          var casesToSave = this.buildSingleCaseToSave(this.teacherModel)
        }
        this.fds.saveMultipleCases(casesToSave)
        .then(res => {
          if (this.selectedCase.id == 41) {
            return this.fds.saveAvailableAtACharge(this.buildSaveAvailableAtACharge(casesToSave))
          } else {
            return
          }
        })  
        .then(res => {
          var str = JSON.stringify(res)
          console.log(`Successful saving Multiple Cases: ${str}`)
          this.inizializeModel()
          this.setCommand(this.caseButton[0]['text'])
        })
        .catch(err => {
          var str = JSON.stringify(err)
          alert(`error saving Multiple Cases: ${str}`)
        })
        break;
      case this.caseButton[2]['text'] :   // Delete
        var keyToDelete = this.teacherModel['regDate']
        if (this.selectedCase['component'] == 'special') {keyToDelete = this.groupModel['regDate']}
        if (this.selectedCase['component'] == 'group') {keyToDelete = this.groupModel['regDate']}
        this.fds.deleteCaseAndCorrelate(this.fds.MAX_KEY-keyToDelete)
        .then(res => {
          var str = JSON.stringify(res) || 'no res'
          console.log(`Successful delete Case And Correlate: ${str}`)
          this.inizializeModel()
          this.setCommand(this.caseButton[2]['text'])
        })
        .catch(err => {
          var str = JSON.stringify(err)
          alert(`error delete Case And Correlate: ${str}`)
        })
        break;
      default :
    }
  }

  private setCommand(from) {
    switch (from) {
      case this.caseButton[1]['text'] :     // Revert
        this.caseButton[0]['enabled'] = false
        this.caseButton[0]['text'] = 'Save'
        this.caseButton[1]['enabled'] = true
        this.caseButton[2]['enabled'] = false
        this.caseButton[3]['enabled'] = false
        break;
      case this.caseButton[3]['text'] :     // Add Teacher
        this.caseButton[0]['enabled'] = this.formControl['canSave'] ? true : false
        this.caseButton[1]['enabled'] = true
        this.caseButton[2]['enabled'] = false
        this.caseButton[3]['enabled'] = false
        break;
      case this.caseButton[0]['text'] :     // Save or Update
        this.caseButton[0]['enabled'] = false
        this.caseButton[0]['text'] = 'Save'
        this.caseButton[1]['enabled'] = false
        this.caseButton[2]['enabled'] = false
        this.caseButton[3]['enabled'] = false
        break;
      case this.caseButton[2]['text'] :     // Delete
        this.caseButton[0]['enabled'] = false
        this.caseButton[0]['text'] = 'Save'
        this.caseButton[1]['enabled'] = false
        this.caseButton[2]['enabled'] = false
        this.caseButton[3]['enabled'] = false
        break;
      case 'teacherIsChanged' :
        if (this.teacherModel['teacher'] && this.teacherModel['groupModel']['showAddTeacher'] ) {this.caseButton[3]['enabled'] = true}
        if (this.teacherModel['teacher'] && !this.teacherModel['groupModel']['schedule'] && this.checkSchedule('teacher')) {
          this.caseButton[0]['enabled'] = this.formControl['canSave'] ? true : false
          this.caseButton[1]['enabled'] = true
        } else {
          if (!this.teacherModel['groupModel']['teachers']) {
            this.caseButton[0]['enabled'] = false
            this.caseButton[1]['enabled'] = true
          }
        }
        //this.groupModel['disableModel'] = this.groupModel['teachers'].length == 0 ? false : true
        //this.groupModelChanges++
        break;
      case 'groupIsChanged' :
        if (this.groupModel['teachers'].length == 0) {
          if (this.groupModel['caseProperty']['component'] !== 'group') {
            this.caseButton[0]['enabled'] = false
            this.caseButton[1]['enabled'] = true
            this.groupModel['disableModel'] = false
          } else {
            this.caseButton[0]['enabled'] = false
            this.caseButton[1]['enabled'] = true
          }
        } else {
          this.groupModel['disableModel'] = true
        }
        if (this.checkSchedule('group') && this.groupModel['group'] && this.groupModel['caseProperty']['component'] == 'special') {
          this.teacherModel['showComponent'] = true
        } else {
          this.teacherModel['showComponent'] = false
        }
        if (this.checkSchedule('group') && this.groupModel['group'] && this.groupModel['caseProperty']['component'] == 'group') {
          this.caseButton[0]['enabled'] = true
        }
        break;
      case 'gridIsSelected' :
        if (!this.teacherModel['regRecovery']) {
          this.caseButton[0]['enabled'] = false
          this.caseButton[0]['text'] = 'Update'
          this.caseButton[1]['enabled'] = true
          this.caseButton[2]['enabled'] = true
        } else {
          this.caseButton[0]['enabled'] = false
          this.caseButton[1]['enabled'] = true
          this.caseButton[2]['enabled'] = true
          this.formControl['canSave'] = false
          this.formControl['message'] = 
          "Attenzione: questo evento ha una o più sostituzioni collegate e non può più essere modificato, solo cancellato, se necessario"
        }
        break;
      case 'isCase15' :
        this.caseButton[3]['show'] = true
        this.groupModel['showComponent'] = true
        break;
      case 'isCaseNot15' :
        this.teacherModel['showComponent'] = this.selectedCase['component'] == 'teacher' ? true : false
        this.groupModel['showComponent'] = this.selectedCase['component'] == 'group' ? true : false
        break;
      default :
    }
  }

  private checkSchedule(par) {         // verify if at last settled field or some sched are checked 
    var  someSchedule = false
    if (par == 'group') {
      if (this.groupModel['settled']) {someSchedule = true}
        for (var d in this.groupModel['schedule']) {
          for (var s in this.groupModel['schedule'][d]['value']) {
            if (this.groupModel['schedule'][d]['value'][s]['value'] == true) {someSchedule = true}
          }
        }
    }
    if (par == 'teacher') {
      if (this.teacherModel['settled']) {someSchedule = true}
        for (var d in this.teacherModel['schedule']) {
          for (var s in this.teacherModel['schedule'][d]['value']) {
            if (this.teacherModel['schedule'][d]['value'][s]['value'] == true) {someSchedule = true}
          }
        }
    }
    //console.log("Some Schedule...:", someSchedule)
    return someSchedule
  }

  private buildCasesToSave(data) {
    var caseDataRecords = []
    var currentDate = Date.now()
    var editDate = 0
    var group = data['group'] ? data['group'] +' ' : null
    const caseDataPrincipal: CaseData = {
      caseId: Number(data['caseProperty']['id']),
      caseName: data['caseProperty']['name'],
      caseType: data['caseProperty']['type'],
      regDate: currentDate,
      editDate: editDate,
      firstTeacher: 'E::'+ data['group'],
      secondTeacher: '',
      startDate: data['startDate'],
      endDate: data['endDate'],
      previousEndDate: data['previousEndDate'] || 0,
      settled: data['settled'],
      note: data['note'],
      classes: {},
      regRecovery: {},
      regDateLinked: [],
      endDateLinked: [],
      absenceLinked: []
    };
    if (!data['settled']) {
      for (var s in data['schedule'][0]['value']) {
        if (data['schedule'][0]['value'][s]['value']) {
          caseDataPrincipal['classes'][data['schedule'][0]['value'][s]['sched']] = data['group']
        }
      }
    }
    caseDataPrincipal['endDateLinked'].push(data['endDate'].toString() +'-'+ currentDate.toString())
    //caseDataRecords.push(caseDataPrincipal)
    var teachers = data.teachers
    for (var rec in teachers) {
      var caseDataCorrelated: CaseData = {
        caseId: Number(teachers[rec]['caseProperty']['id']),
        caseName: teachers[rec]['caseProperty']['name'],
        caseType: teachers[rec]['caseProperty']['type'],
        regDate: ++currentDate,
        editDate: editDate,
        firstTeacher: teachers[rec]['type']+'::'+ teachers[rec]['teacher'],
        secondTeacher: '',
        startDate: teachers[rec]['startDate'],
        endDate: teachers[rec]['endDate'],
        previousEndDate: teachers[rec]['previousEndDate'] || 0,
        settled: teachers[rec]['settled'],
        note: group + teachers[rec]['note'],
        classes: {},
        regRecovery: {},
        regDateLinked: [],
        endDateLinked: [],
        absenceLinked: []
      };
      if(!data['settled'] && teachers[rec]['schedule'][0]) {
        for (var s in teachers[rec]['schedule'][0]['value']) {
          if (teachers[rec]['schedule'][0]['value'][s]['value']) {
            caseDataCorrelated['classes'][teachers[rec]['schedule'][0]['value'][s]['sched']] = teachers[rec]['schedule'][0]['value'][s]['group'] || true
          }
        }
      }
      caseDataPrincipal['regDateLinked'].push(this.fds.MAX_KEY-caseDataCorrelated.regDate)
      caseDataPrincipal['endDateLinked'].push(caseDataCorrelated.endDate.toString() +'-'+ caseDataCorrelated.regDate.toString())
      caseDataRecords.push(caseDataCorrelated)
    }
    caseDataRecords.push(caseDataPrincipal)
    return caseDataRecords
  }

  private buildSingleCaseToSave(data) {
    var caseDataRecords = [], teachers = [], regDate = 0, editDate = 0
    if (data['isEditingMode']) {
      regDate = data['regDate']
      editDate = Date.now()
    } else {
      regDate = Date.now()
    }
    teachers.push(data)
    for (var rec in teachers) {
      if (teachers[rec]['group']) {
        teachers[rec]['type'] = 'E'
        teachers[rec]['teacher'] = teachers[rec]['group']
      }                            
      var caseDataRecord: CaseData = {
        caseId: Number(teachers[rec]['caseProperty']['id']) || teachers[rec]['caseId'],
        caseName: teachers[rec]['caseProperty']['name'] || teachers[rec]['caseName'],
        caseType: teachers[rec]['caseProperty']['type'] || teachers[rec]['caseType'],
        regDate: regDate,
        editDate: editDate,
        firstTeacher: teachers[rec]['type']+'::'+ teachers[rec]['teacher'],
        secondTeacher: '',
        startDate: teachers[rec]['startDate'],
        endDate: teachers[rec]['endDate'],
        previousEndDate: teachers[rec]['previousEndDate'] || 0,
        settled: teachers[rec]['settled'],
        note: teachers[rec]['note'],
        classes: {},
        regRecovery: teachers[rec]['regRecovery'] || {},
        regDateLinked: [],
        endDateLinked: [],
        absenceLinked: []
      };
      var caseType = teachers[rec]['caseProperty']['type'] || teachers[rec]['caseType']
      if(!data['settled']  && teachers[rec]['schedule'][0] && caseType !== 'P') {
        for (var s in teachers[rec]['schedule'][0]['value']) {
          if (teachers[rec]['schedule'][0]['value'][s]['value']) {
            caseDataRecord['classes'][teachers[rec]['schedule'][0]['value'][s]['sched']] = teachers[rec]['schedule'][0]['value'][s]['group'] || true
          }
        }
      }
      if(caseType !== 'P' ) {
        caseDataRecord['endDateLinked'].push(caseDataRecord['endDate'].toString() +'-'+ caseDataRecord['regDate'].toString())
      }
      caseDataRecords.push(caseDataRecord)
    }
    console.log("Single case ...:", caseDataRecords)
    return caseDataRecords
  }
 
  private buildSaveAvailableAtACharge(casesToSave) {
    //console.log("record avaialbility Cases to save....: ", casesToSave[0])
    var item = {}
    item['teacher'] = casesToSave[0]['firstTeacher']
    item['endDate'] = casesToSave[0]['endDate']
    item['startDate'] = casesToSave[0]['startDate']
    item['regDate'] = casesToSave[0]['regDate']
    item['editDate'] = casesToSave[0]['editDate']
    item['previousEndDate'] = casesToSave[0]['previousEndDate']
    item['schedule'] = {}
    for (var s in this.teacherModel['schedule']) {
      var schedDay = this.teacherModel['schedule'][s]
      for (var t in schedDay['value']) {
        if (schedDay['value'][t]['value']) {
          if (!item['schedule'][schedDay['day']]) {item['schedule'][schedDay['day']] = {}}
          item['schedule'][schedDay['day']][schedDay['value'][t]['sched']] = true
        }
      }
    }
    console.log("record avaialbility ....: ", item) 
    return item
  }


// end of module
}



// WEBPACK FOOTER //
// c:/Dev/Angular/liceo/src/app/case-master/case-master.component.ts